module.exports = __webpack_public_path__ + "b7573f8b127e15180a95662b6ca5d84a.pdf";